(function BundleWizard() {
    const CONTAINER_ID = 'simple-bundles-io-options';
    const FORM_BUTTONS_SEL = '.product-form__buttons';

    function init(container) {
        const sections = parseSections(container);
        if (sections.length < 2) return;

        createWizard(container, sections);

        // --- FIRE FAIRWAY WOOD 1 → SHAFT LENGTH FILTERING ---
        (function setupFW1LengthFiltering() {
            const fw1Label = [...document.querySelectorAll('label')]
                .find(l => l.textContent.trim() === 'FIRE FAIRWAY WOOD 1');
            if (!fw1Label) return;
            fw1Label.classList.add("bundle-top-label--wood1");

            const fw1LoftSelect = fw1Label.nextElementSibling;
            if (!fw1LoftSelect) return;

            let fw1LengthSelect = null;
            let el = fw1Label;

            while (el = el.nextElementSibling) {
                if (el.tagName === 'LABEL' && el.textContent.trim() === 'FIRE FAIRWAY WOOD 2') break;
                if (el.tagName === 'LABEL' && el.textContent.trim() === 'Shaft Length') {
                    fw1LengthSelect = el.nextElementSibling;
                    break;
                }
            }

            if (!fw1LengthSelect) return;

            const originalFW1 = [...fw1LengthSelect.options].map(o => ({
                value: o.value,
                text: o.textContent.trim()
            }));

            const fw1Allowed = {
                "2 Wood 10°": ["42", "42.5", "43 (Standard)", "43.5", "44"],
                "3+ Wood 13°": ["42", "42.5", "43 (Standard)", "43.5", "44"],
                "3 Wood 15°": ["42", "42.5", "43 (Standard)", "43.5", "44"],
                "5 Wood 19°": ["41", "41.5", "42 (Standard)", "42.5", "43"],
                "7 Wood 23°": ["40", "40.5", "41 (Standard)", "41.5", "42"],
                "9 Wood 27°": ["39.25", "39.75", "40.25 (Standard)", "40.75", "41.25"],
                "11 Wood 31°": ["38.75", "39.25", "39.75 (Standard)", "40.25", "40.75"],
                "13 Wood 35°": ["37.5", "38", "38.5 (Standard)", "39", "39.5"],
                "15 Wood 39°": ["37", "37.5", "38 (Standard)", "38.5", "39"]
            };

            fw1LoftSelect.addEventListener('change', () => {
                const chosen = fw1LoftSelect.value;
                fw1LengthSelect.innerHTML = "";
                fw1LengthSelect.appendChild(new Option("Please select", ""));

                const allow = fw1Allowed[chosen];
                if (!allow) return;

                originalFW1.forEach(opt => {
                    if (allow.includes(opt.text)) {
                        fw1LengthSelect.appendChild(new Option(opt.text, opt.value));
                    }
                });

                fw1LengthSelect.value = "";
            });
        })();

        // --- FIRE FAIRWAY WOOD 1 IMAGE SELECTOR ---
        (function setupWood1ImageSelector() {
            const wood1Select = [...document.querySelectorAll('label')]
                .find(l => l.textContent.trim() === 'FIRE FAIRWAY WOOD 1')
                ?.nextElementSibling;

            if (!wood1Select) return;

            wood1Select.style.display = "none";

            const wrapper = document.createElement("div");
            wrapper.className = "bundle-image__container";
            wood1Select.parentNode.insertBefore(wrapper, wood1Select);

            const options = [
                { value: "2 Wood 10°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/2-FFW.webp?v=1764721457", label: "2 Wood 10°" },
                { value: "3+ Wood 13°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/3plus-FFW.webp?v=1764721457", label: "3+ Wood 13°" },
                { value: "3 Wood 15°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/3-FFW.webp?v=1764721457", label: "3 Wood 15°" },
                { value: "5 Wood 19°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/5-FFW.webp?v=1764721457", label: "5 Wood 19°" },
                { value: "7 Wood 23°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/7-FFW.webp?v=1764721457", label: "7 Wood 23°" },
                { value: "9 Wood 27°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/9-FFW.webp?v=1764721457", label: "9 Wood 27°" },
                { value: "11 Wood 31°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/11-FFW.webp?v=1764721457", label: "11 Wood 31°" },
                { value: "13 Wood 35°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/13-FFW.webp?v=1764721457", label: "13 Wood 35°" },
                { value: "15 Wood 39°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/15-FFW.webp?v=1764721457", label: "15 Wood 39°" }
            ];

            options.forEach(opt => {
                const item = document.createElement("div");
                item.className = "bundle-image__item";

                const img = document.createElement("img");
                img.className = "bundle-image__img";
                img.src = opt.img;
                img.alt = opt.value;

                img.addEventListener("click", () => {
                    wood1Select.value = opt.value;

                    [...wrapper.querySelectorAll("img")].forEach(i => {
                        i.style.transform = "scale(1)";
                        i.style.boxShadow = "none";
                        i.style.borderRadius = "0";
                    });

                    img.style.transform = "scale(1.06)";
                    img.style.boxShadow = "0 0 20px rgba(0,0,0,0.25)";
                    img.style.borderRadius = "8px";

                    wood1Select.dispatchEvent(new Event('change', { bubbles: true }));
                });

                const label = document.createElement("div");
                label.className = "bundle-wood1-img-label";
                label.textContent = opt.label;

                item.appendChild(label);
                item.appendChild(img);
                wrapper.appendChild(item);
            });
        })();

        // --- FIRE FAIRWAY WOOD 2 → SHAFT LENGTH FILTERING ---
        (function setupFW2LengthFiltering() {
            const fw2Label = [...document.querySelectorAll('label')]
                .find(l => l.textContent.trim() === 'FIRE FAIRWAY WOOD 2');

            if (!fw2Label) return;
            fw2Label.classList.add("bundle-top-label--wood2");

            const fw2LoftSelect = fw2Label.nextElementSibling;
            if (!fw2LoftSelect) return;

            let fw2LengthSelect = null;
            let el = fw2Label;

            while (el = el.nextElementSibling) {
                if (el.tagName === 'LABEL' && el.textContent.trim() === 'FIRE FAIRWAY WOOD 3') break;
                if (el.tagName === 'LABEL' && el.textContent.trim() === 'Shaft Length') {
                    fw2LengthSelect = el.nextElementSibling;
                    break;
                }
            }

            if (!fw2LengthSelect) return;

            const originalFW2 = [...fw2LengthSelect.options].map(o => ({
                value: o.value,
                text: o.textContent.trim()
            }));

            const fw2Allowed = {
                "2 Wood 10°": ["42", "42.5", "43 (Standard)", "43.5", "44"],
                "3+ Wood 13°": ["42", "42.5", "43 (Standard)", "43.5", "44"],
                "3 Wood 15°": ["42", "42.5", "43 (Standard)", "43.5", "44"],
                "5 Wood 19°": ["41", "41.5", "42 (Standard)", "42.5", "43"],
                "7 Wood 23°": ["40", "40.5", "41 (Standard)", "41.5", "42"],
                "9 Wood 27°": ["39.25", "39.75", "40.25 (Standard)", "40.75", "41.25"],
                "11 Wood 31°": ["38.75", "39.25", "39.75 (Standard)", "40.25", "40.75"],
                "13 Wood 35°": ["37.5", "38", "38.5 (Standard)", "39", "39.5"],
                "15 Wood 39°": ["37", "37.5", "38 (Standard)", "38.5", "39"]
            };

            fw2LoftSelect.addEventListener('change', () => {
                const chosen = fw2LoftSelect.value;
                fw2LengthSelect.innerHTML = "";
                fw2LengthSelect.appendChild(new Option("Please select", ""));

                const allow = fw2Allowed[chosen];
                if (!allow) return;

                originalFW2.forEach(opt => {
                    if (allow.includes(opt.text)) {
                        fw2LengthSelect.appendChild(new Option(opt.text, opt.value));
                    }
                });

                fw2LengthSelect.value = "";
            });
        })();

        // --- FIRE FAIRWAY WOOD 2 IMAGE SELECTOR ---
        (function setupWood2ImageSelector() {
            const wood2Select = [...document.querySelectorAll('label')]
                .find(l => l.textContent.trim() === 'FIRE FAIRWAY WOOD 2')
                ?.nextElementSibling;

            if (!wood2Select) return;

            wood2Select.style.display = "none";

            const wrapper = document.createElement("div");
            wrapper.className = "bundle-image__container";
            wood2Select.parentNode.insertBefore(wrapper, wood2Select);

            const options = [
                { value: "2 Wood 10°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/2-FFW.webp?v=1764721457", label: "2 Wood 10°" },
                { value: "3+ Wood 13°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/3plus-FFW.webp?v=1764721457", label: "3+ Wood 13°" },
                { value: "3 Wood 15°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/3-FFW.webp?v=1764721457", label: "3 Wood 15°" },
                { value: "5 Wood 19°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/5-FFW.webp?v=1764721457", label: "5 Wood 19°" },
                { value: "7 Wood 23°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/7-FFW.webp?v=1764721457", label: "7 Wood 23°" },
                { value: "9 Wood 27°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/9-FFW.webp?v=1764721457", label: "9 Wood 27°" },
                { value: "11 Wood 31°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/11-FFW.webp?v=1764721457", label: "11 Wood 31°" },
                { value: "13 Wood 35°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/13-FFW.webp?v=1764721457", label: "13 Wood 35°" },
                { value: "15 Wood 39°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/15-FFW.webp?v=1764721457", label: "15 Wood 39°" }
            ];

            options.forEach(opt => {
                const item = document.createElement("div");
                item.className = "bundle-image__item";

                const img = document.createElement("img");
                img.className = "bundle-image__img";
                img.src = opt.img;
                img.alt = opt.value;

                img.addEventListener("click", () => {
                    wood2Select.value = opt.value;

                    [...wrapper.querySelectorAll("img")].forEach(i => {
                        i.style.transform = "scale(1)";
                        i.style.boxShadow = "none";
                        i.style.borderRadius = "0";
                    });

                    img.style.transform = "scale(1.06)";
                    img.style.boxShadow = "0 0 20px rgba(0,0,0,0.25)";
                    img.style.borderRadius = "8px";

                    wood2Select.dispatchEvent(new Event('change', { bubbles: true }));
                });

                const label = document.createElement("div");
                label.className = "bundle-wood2-img-label";
                label.textContent = opt.label;

                item.appendChild(label);
                item.appendChild(img);
                wrapper.appendChild(item);
            });
        })();

        // --- FIRE FAIRWAY WOOD 3 → SHAFT LENGTH FILTERING ---
        (function setupFW3LengthFiltering() {
            const fw3Label = [...document.querySelectorAll('label')]
                .find(l => l.textContent.trim() === 'FIRE FAIRWAY WOOD 3');

            if (!fw3Label) return;
            fw3Label.classList.add("bundle-top-label--wood3");

            const fw3LoftSelect = fw3Label.nextElementSibling;
            if (!fw3LoftSelect) return;

            let fw3LengthSelect = null;
            let el = fw3Label;

            while (el = el.nextElementSibling) {
                if (el.tagName === 'LABEL' && el.textContent.trim().startsWith('FIRE ')) break;
                if (el.tagName === 'LABEL' && el.textContent.trim() === 'Shaft Length') {
                    fw3LengthSelect = el.nextElementSibling;
                    break;
                }
            }

            if (!fw3LengthSelect) return;

            const originalFW3 = [...fw3LengthSelect.options].map(o => ({
                value: o.value,
                text: o.textContent.trim()
            }));

            const fw3Allowed = {
                "2 Wood 10°": ["42", "42.5", "43 (Standard)", "43.5", "44"],
                "3+ Wood 13°": ["42", "42.5", "43 (Standard)", "43.5", "44"],
                "3 Wood 15°": ["42", "42.5", "43 (Standard)", "43.5", "44"],
                "5 Wood 19°": ["41", "41.5", "42 (Standard)", "42.5", "43"],
                "7 Wood 23°": ["40", "40.5", "41 (Standard)", "41.5", "42"],
                "9 Wood 27°": ["39.25", "39.75", "40.25 (Standard)", "40.75", "41.25"],
                "11 Wood 31°": ["38.75", "39.25", "39.75 (Standard)", "40.25", "40.75"],
                "13 Wood 35°": ["37.5", "38", "38.5 (Standard)", "39", "39.5"],
                "15 Wood 39°": ["37", "37.5", "38 (Standard)", "38.5", "39"]
            };

            fw3LoftSelect.addEventListener('change', () => {
                const chosen = fw3LoftSelect.value;
                fw3LengthSelect.innerHTML = "";
                fw3LengthSelect.appendChild(new Option("Please select", ""));

                const allow = fw3Allowed[chosen];
                if (!allow) return;

                originalFW3.forEach(opt => {
                    if (allow.includes(opt.text)) {
                        fw3LengthSelect.appendChild(new Option(opt.text, opt.value));
                    }
                });

                fw3LengthSelect.value = "";
            });
        })();

        // --- FIRE FAIRWAY WOOD 3 IMAGE SELECTOR ---
        (function setupWood3ImageSelector() {
            const wood3Select = [...document.querySelectorAll('label')]
                .find(l => l.textContent.trim() === 'FIRE FAIRWAY WOOD 3')
                ?.nextElementSibling;

            if (!wood3Select) return;

            wood3Select.style.display = "none";

            const wrapper = document.createElement("div");
            wrapper.className = "bundle-image__container";
            wood3Select.parentNode.insertBefore(wrapper, wood3Select);

            const options = [
                { value: "2 Wood 10°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/2-FFW.webp?v=1764721457", label: "2 Wood 10°" },
                { value: "3+ Wood 13°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/3plus-FFW.webp?v=1764721457", label: "3+ Wood 13°" },
                { value: "3 Wood 15°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/3-FFW.webp?v=1764721457", label: "3 Wood 15°" },
                { value: "5 Wood 19°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/5-FFW.webp?v=1764721457", label: "5 Wood 19°" },
                { value: "7 Wood 23°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/7-FFW.webp?v=1764721457", label: "7 Wood 23°" },
                { value: "9 Wood 27°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/9-FFW.webp?v=1764721457", label: "9 Wood 27°" },
                { value: "11 Wood 31°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/11-FFW.webp?v=1764721457", label: "11 Wood 31°" },
                { value: "13 Wood 35°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/13-FFW.webp?v=1764721457", label: "13 Wood 35°" },
                { value: "15 Wood 39°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/15-FFW.webp?v=1764721457", label: "15 Wood 39°" }
            ];

            options.forEach(opt => {
                const item = document.createElement("div");
                item.className = "bundle-image__item";

                const img = document.createElement("img");
                img.className = "bundle-image__img";
                img.src = opt.img;
                img.alt = opt.value;

                img.addEventListener("click", () => {
                    wood3Select.value = opt.value;

                    [...wrapper.querySelectorAll("img")].forEach(i => {
                        i.style.transform = "scale(1)";
                        i.style.boxShadow = "none";
                        i.style.borderRadius = "0";
                    });

                    img.style.transform = "scale(1.06)";
                    img.style.boxShadow = "0 0 20px rgba(0,0,0,0.25)";
                    img.style.borderRadius = "8px";

                    wood3Select.dispatchEvent(new Event('change', { bubbles: true }));
                });

                const label = document.createElement("div");
                label.className = "bundle-wood3-img-label";
                label.textContent = opt.label;

                item.appendChild(label);
                item.appendChild(img);
                wrapper.appendChild(item);
            });
        })();
        // --- CONTROL BUNDLE: LEFT HAND 11 AND 13 WOODS SOLD OUT ---
        (function setupControlBundleSoldOutOptions() {
            function setupWoodSoldOut(labelText) {
                const woodLabel = [...container.querySelectorAll('label')]
                    .find(label =>
                        label.textContent.trim() === labelText
                    );

                const woodStep = woodLabel?.closest('.bw-step');
                const woodSelect = woodStep?.querySelector('select');

                const handSelect = [...(woodStep?.querySelectorAll('label') || [])]
                    .find(label => label.textContent.trim() === 'Hand')
                    ?.nextElementSibling;

                if (!woodSelect || !handSelect) return;

                const leftHandOption = [...handSelect.options]
                    .find(option =>
                        option.textContent
                            .replace(/\s*-\s*Sold out$/i, '')
                            .trim() === 'Left Hand'
                    );

                if (!leftHandOption) return;

                function updateWoodSoldOut() {
                    const isSoldOut = [
                        '7 Wood 23°',
                        '11 Wood 31°',
                        '13 Wood 35°'
                    ].includes(woodSelect.value);

                    leftHandOption.disabled = isSoldOut;
                    leftHandOption.textContent = isSoldOut
                        ? 'Left Hand - Sold out'
                        : 'Left Hand';

                    if (
                        isSoldOut &&
                        handSelect.value === leftHandOption.value
                    ) {
                        handSelect.value = '';

                        handSelect.dispatchEvent(
                            new Event('change', { bubbles: true })
                        );
                    }
                }

                woodSelect.addEventListener(
                    'change',
                    updateWoodSoldOut
                );

                updateWoodSoldOut();
            }

            setupWoodSoldOut('FIRE FAIRWAY WOOD 1');
            setupWoodSoldOut('FIRE FAIRWAY WOOD 2');
            setupWoodSoldOut('FIRE FAIRWAY WOOD 3');
        })();
    }

    function parseSections(container) {
        const sectionMap = new Map();

        const GROUPS = {
            "FIRE FAIRWAY WOOD 1": "FIRE FAIRWAY WOOD 1",
            "FIRE FAIRWAY WOOD 2": "FIRE FAIRWAY WOOD 2",
            "FIRE FAIRWAY WOOD 3": "FIRE FAIRWAY WOOD 3"
        };

        Array.from(container.children).forEach(el => {
            if (el.tagName === 'LABEL') {
                const full = el.textContent.trim();
                let groupName = null;

                Object.keys(GROUPS).forEach(prefix => {
                    if (full.startsWith(prefix)) groupName = GROUPS[prefix];
                });

                if (groupName) {
                    if (!sectionMap.has(groupName)) {
                        sectionMap.set(groupName, { name: groupName, elements: [] });
                    }
                    sectionMap.get(groupName).elements.push(el);
                }
            } else if (el.tagName === 'SELECT') {
                const lastSection = Array.from(sectionMap.values()).pop();
                if (lastSection) lastSection.elements.push(el);
            }
        });

        return Array.from(sectionMap.values());
    }

    function createWizard(container, sections) {
        let step = 0;
        const formButtons = document.querySelector(FORM_BUTTONS_SEL);

        // Cache correct selects for validation
        const fw1Select = [...document.querySelectorAll('label')]
            .find(l => l.textContent.trim() === 'FIRE FAIRWAY WOOD 1')
            ?.nextElementSibling;

        const fw2Select = [...document.querySelectorAll('label')]
            .find(l => l.textContent.trim() === 'FIRE FAIRWAY WOOD 2')
            ?.nextElementSibling;

        const fw3Select = [...document.querySelectorAll('label')]
            .find(l => l.textContent.trim() === 'FIRE FAIRWAY WOOD 3')
            ?.nextElementSibling;

        const tabBar = document.createElement('div');
        tabBar.className = 'bw-tabs';
        sections.forEach((section, i) => {
            const tabBtn = document.createElement('button');
            tabBtn.type = 'button';
            tabBtn.className = 'bw-tab';
            tabBtn.textContent = section.name;
            tabBtn.dataset.step = i;
            tabBtn.addEventListener('click', () => {
                step = i;
                render();
            });
            tabBar.appendChild(tabBtn);
            section.tab = tabBtn;
        });
        container.insertBefore(tabBar, container.firstChild);

        sections.forEach((section, i) => {
            const wrapper = document.createElement('div');
            wrapper.className = 'bw-step' + (i === 0 ? ' active' : '');
            wrapper.dataset.step = i;

            const header = document.createElement('h3');
            header.className = 'bw-step-header';
            header.textContent = `Select ${section.name} Options`;
            wrapper.appendChild(header);

            section.elements.forEach(el => {
                if (el.tagName === 'LABEL') {
                    el.classList.add("bundle-section-label");
                    el.textContent = el.textContent.replace(/^([^–-]+)\s*[–-]\s*/, '');
                }
                wrapper.appendChild(el);
            });

            container.appendChild(wrapper);
            section.wrapper = wrapper;
            section.selects = wrapper.querySelectorAll('select[required]');
        });

        const nav = document.createElement('div');
        nav.className = 'bw-nav';
        nav.innerHTML = `
      <button type="button" class="bw-prev button button--secondary bw-hidden">Previous</button>
      <button type="button" class="bw-next button button--secondary"></button>
    `;
        container.appendChild(nav);

        const prevBtn = nav.querySelector('.bw-prev');
        const nextBtn = nav.querySelector('.bw-next');

        const isFilled = (section) =>
            Array.from(section.selects).every(sel => sel.value);

        const allFilled = () => sections.every(isFilled);

        function render() {
            sections.forEach((s, i) => {
                s.wrapper.classList.toggle('active', i === step);
                if (s.tab) {
                    s.tab.classList.toggle('active', i === step);
                }
            });

            prevBtn.classList.toggle('bw-hidden', step === 0);

            const isLast = step === sections.length - 1;

            if (isLast) {
                nextBtn.classList.add('bw-hidden');
                formButtons?.classList.toggle('bw-hidden', !allFilled());
            } else {
                nextBtn.classList.remove('bw-hidden');
                nextBtn.textContent = `Next: ${sections[step + 1].name}`;
                formButtons?.classList.add('bw-hidden');
            }
        }

        prevBtn.addEventListener('click', () => {
            if (step > 0) { step--; render(); }
        });

        nextBtn.addEventListener('click', () => {

            // STEP 0 – WOOD 1 REQUIRED
            if (step === 0) {
                if (!fw1Select || !fw1Select.value) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Selection Required',
                        text: 'Please select a FIRE FAIRWAY WOOD 1 before continuing.',
                        confirmButtonText: 'OK'
                    });
                    return;
                }
            }

            // STEP 1 – WOOD 2 REQUIRED
            if (step === 1) {
                if (!fw2Select || !fw2Select.value) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Selection Required',
                        text: 'Please select a FIRE FAIRWAY WOOD 2 before continuing.',
                        confirmButtonText: 'OK'
                    });
                    return;
                }
            }

            // STEP 2 – WOOD 3 REQUIRED
            if (step === 2) {
                if (!fw3Select || !fw3Select.value) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Selection Required',
                        text: 'Please select a FIRE FAIRWAY WOOD 3 before continuing.',
                        confirmButtonText: 'OK'
                    });
                    return;
                }
            }

            if (!isFilled(sections[step])) {
                sections[step].selects.forEach(sel => {
                    if (!sel.value) sel.reportValidity();
                });
                return;
            }

            step++;
            render();
        });

        container.addEventListener('change', render);
        render();
    }

    function observe() {
        const el = document.getElementById(CONTAINER_ID);
        if (el) {
            init(el);
            return true;
        }
        return false;
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            if (!observe()) {
                new MutationObserver((_, obs) => {
                    if (observe()) obs.disconnect();
                }).observe(document.body, { childList: true, subtree: true });
            }
        });
    } else if (!observe()) {
        new MutationObserver((_, obs) => {
            if (observe()) obs.disconnect();
        }).observe(document.body, { childList: true, subtree: true });
    }

})();


// "Choose your" LABEL PATCH
new MutationObserver(() => {
    const lbl1 = document.querySelector('.bundle-top-label--wood1');
    const lbl2 = document.querySelector('.bundle-top-label--wood2');
    const lbl3 = document.querySelector('.bundle-top-label--wood3');

    if (lbl1 && !lbl1.dataset.patched) {
        lbl1.textContent = "Choose your " + lbl1.textContent.trim();
        lbl1.dataset.patched = "1";
    }

    if (lbl2 && !lbl2.dataset.patched) {
        lbl2.textContent = "Choose your " + lbl2.textContent.trim();
        lbl2.dataset.patched = "1";
    }

    if (lbl3 && !lbl3.dataset.patched) {
        lbl3.textContent = "Choose your " + lbl3.textContent.trim();
        lbl3.dataset.patched = "1";
    }

}).observe(document.body, { childList: true, subtree: true });
